import { CustomField } from '../types/custom-fields/types';

const BROAD_SPECIALTY_IDENTIFIERS = new Set(['Broad-specialty']);

export interface Option {
  label: string;
  value: string;
}

export const extractBroadSpecialtyOptions = (
  customFields: CustomField[] | undefined | null
): Option[] => {
  if (!Array.isArray(customFields) || customFields.length === 0) {
    return [];
  }

  const field = customFields.find(
    (item) =>
      BROAD_SPECIALTY_IDENTIFIERS.has(item.name) ||
      BROAD_SPECIALTY_IDENTIFIERS.has(item.field_type)
  );

  if (!field) {
    return [];
  }

  if (!Array.isArray(field.allowed_values)) {
    return [];
  }

  const options = [...field.allowed_values]
    .filter(
      (value) =>
        value &&
        typeof value.value === 'string' &&
        value.value.trim().length > 0
    )
    .sort((a, b) => (a.sort_order ?? 0) - (b.sort_order ?? 0))
    .map((item) => ({
      label: item.value,
      value: item.value,
    }));

  return options;
};

export const extractSpecialtyOptions = (
  customFields: CustomField[] | undefined | null
): Option[] => {
  if (!Array.isArray(customFields) || customFields.length === 0) {
    return [];
  }

  const field = customFields.find(
    (item) => item.field_type === 'Specialty' || item.name === 'Specialty'
  );

  if (!field || !Array.isArray(field.allowed_values)) {
    return [];
  }

  return [...field.allowed_values]
    .filter(
      (value) =>
        value &&
        typeof value.value === 'string' &&
        value.value.trim().length > 0
    )
    .sort((a, b) => (a.sort_order ?? 0) - (b.sort_order ?? 0))
    .map((item) => ({
      label: item.value,
      value: item.value,
    }));
};

